module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.debug_show_page_name == true) ? _c('div', {
    staticStyle: {
      "color": "green"
    }
  }, [_vm._v("\n    page_0090_notice\n  ")]) : _vm._e(), _vm._v(" "), _c('app-header', [_vm._v("esma")]), _vm._v(" "), _c('div', {
    class: 'container ' + _vm.pageContainerSize
  }, [_c('title-and-search', {
    attrs: {
      "title": _vm.pageTitle
    }
  }), _vm._v(" "), _c('tabs', {
    attrs: {
      "nav-style": "tabs",
      "value": _vm.selectedTab
    },
    on: {
      "active": function($event) {
        _vm.onTabChanged($event)
      }
    }
  }, [_c('tab', {
    attrs: {
      "header": "お知らせ"
    }
  }), _vm._v(" "), _c('tab', {
    attrs: {
      "header": "お知らせ 履歴一覧"
    }
  })], 1), _vm._v(" "), _c('search-control', {
    staticStyle: {
      "padding-bottom": "10px"
    },
    attrs: {
      "field_names": _vm.allFields
    },
    on: {
      "change": _vm.searchControlChangedDatasource
    }
  }), _vm._v(" "), _c('ag-grid-vue', {
    staticClass: "ag-blue",
    staticStyle: {
      "width": "100%",
      "height": "325px"
    },
    attrs: {
      "gridOptions": _vm.gridOptions
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-top": "5px"
    }
  }, [_c('br'), _vm._v(" "), _c('button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (this.selectedTab == 0),
      expression: "this.selectedTab == 0"
    }],
    staticClass: "btn btn-primary",
    staticStyle: {
      "min-width": "100px",
      "float": "right",
      "margin-left": "10px",
      "background": "#92D050",
      "border-color": "#92D050"
    },
    attrs: {
      "disabled": _vm.checkUserPermission(true, _vm.permissionMode.ADD) == false
    },
    on: {
      "click": _vm.addNew
    }
  }, [_vm._v("\n        新規\n      ")])])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-57d84c34","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/page_0090_notice.vue
// module id = 994
// module chunks = 0